module.exports = __webpack_public_path__ + "img/paragraph-3.97508b8f.svg";